/**
 * Generic component that has a search field to search for a type of user, returns
 * the matching users along along with a table below to select and filter.
 */
import { types } from "api";
import { InfoSnackBar } from "components/InfoSnackBar";
import { ADDED_USR } from "messages";
import { useEffect, useState } from "react";
import { CustomMultiSearch } from "./CustomMultiSearch";
import { UserTable } from "./UserTable";

export interface UserSearchProps {
	role: types.RoleType;
	users: types.User[];
	setUsers: (users: types.User[]) => void;
}

export const UserSearch = ({
	role,
	users,
	setUsers,
}: UserSearchProps): JSX.Element => {
	const [userToAdd, setUserToAdd] = useState<types.User | null>(null);
	const [succAdded, setSuccAdded] = useState<boolean>(false);

	useEffect(() => {
		if (userToAdd && !users.some((user) => user.userId === userToAdd.userId)) {
			setUsers([...users, userToAdd]);
			setSuccAdded(true);
			setUserToAdd(null);
		}
	}, [users, userToAdd, setUsers]);

	return (
		<div>
			<CustomMultiSearch role={role} handler={setUserToAdd} />
			<UserTable userList={users} userListHandler={setUsers} />
			<InfoSnackBar
				isOpen={succAdded}
				onClose={() => setSuccAdded(false)}
				message={ADDED_USR}
				severity="success"
			/>
		</div>
	);
};
